// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { thumbUp16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-thumb-up': IconThumbUp;
    }
}

/**
 * The icon component for the 'thumbUp' icon
 */
export class IconThumbUp extends Icon {
    public constructor() {
        super(thumbUp16X16);
    }
}

registerIcon('icon-thumb-up', IconThumbUp);
export const iconThumbUpTag = 'nimble-icon-thumb-up';
